(function () {
  'use strict';

  var PRESETS = {
    card: { widths: [400, 600, 900], sizes: '(min-width: 769px) 302px, 78vw' },
    product: { widths: [600, 900, 1200], sizes: '(min-width: 990px) 55vw, 100vw' },
    thumb: { widths: [80, 120, 160], sizes: '80px' },
  };

  function shopifyImageUrl(src, width) {
    if (!src) return '';

    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      if (src.indexOf('width=') > -1) {
        return src.replace(/width=\d+/i, 'width=' + width);
      }
      var joiner = src.indexOf('?') > -1 ? '&' : '?';
      return src + joiner + 'width=' + width;
    }
  }

  function buildSrcset(src, widths) {
    return widths
      .map(function (width) {
        return shopifyImageUrl(src, width) + ' ' + width + 'w';
      })
      .join(', ');
  }

  function apply(img, src, config) {
    if (!img || !src) return;

    config = config || {};
    var preset = PRESETS[config.preset] || PRESETS.product;
    var widths = config.widths || preset.widths;
    var sizes = config.sizes || preset.sizes;
    var maxWidth = widths[widths.length - 1];

    img.src = shopifyImageUrl(src, maxWidth);
    img.srcset = buildSrcset(src, widths);
    img.sizes = sizes;
    img.decoding = config.decoding || (typeof navigator !== 'undefined' && /Safari/i.test(navigator.userAgent) && !/Chrome|CriOS|Chromium|Edg|OPR|Android/i.test(navigator.userAgent) ? 'auto' : 'async');

    img.loading = config.loading || 'lazy';

    if (config.alt != null && String(config.alt).trim() !== '') {
      img.alt = config.alt;
    } else if (!img.hasAttribute('alt') || String(img.getAttribute('alt') || '').trim() === '') {
      if (window.RabitatImageAlt && typeof window.RabitatImageAlt.resolve === 'function') {
        window.RabitatImageAlt.resolve(img);
      } else {
        img.alt = 'Rabitat';
      }
    }
  }

  window.RabitatResponsiveImage = {
    shopifyImageUrl: shopifyImageUrl,
    buildSrcset: buildSrcset,
    apply: apply,
    PRESETS: PRESETS,
  };
})();
